import { render, staticRenderFns } from "./SetShowItems.vue?vue&type=template&id=f50df1a8&"
import script from "./SetShowItems.vue?vue&type=script&lang=js&"
export * from "./SetShowItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports